import { ColumnSort, FiltersRequestResponse, Range } from '@spo/logic';
import { apiOfferPoster, apiSuperModels } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';
import { environment } from '../environments/environment';

export const usePoster = (
  offerDate: string,
  range: Range,
  selectedFilters: FiltersRequestResponse,
  columnSort: ColumnSort,
  language: string,
) => {
  const contentMediaUrl = environment.contentMediaUrl;
  return useQuery({
    queryKey: ['PosterTable', offerDate, language],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const smPath = apiSuperModels.getSMPath(
          offerDate,
          selectedFilters,
          [],
          columnSort,
          range,
        );

        return apiOfferPoster.getOfferPoster({
          offerDate,
          smPath,
          language,
          contentMediaUrl,
        });
      }
    },
    refetchOnWindowFocus: false,
    enabled: !!offerDate,
  });
};
